import React, { useState } from 'react'
import Schedule from '../../../assets/images/scheduleSmall.svg'
import { Flex, ResponsiveSVG } from 'ui/acro'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'

const Container = styled(Flex)({
  padding: '4px 24px',
  gap: '12px',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid #A3A3A3',
  borderRadius: '360px',
  marginTop: '4px',
  marginBottom: '8px',
  cursor: 'pointer'
})
const CTAText = styled(Text)({
  fontSize: ['14px'],
  fontFamily: 'Proxima-nova',
  color: '#000'
})

const AddToCalendarBtnForClassCard = ({ onClick }) => {
  return (
    <>
      <Container onClick={onClick}>
        <ResponsiveSVG
          SVG={Schedule}
          style={{
            cursor: 'pointer'
          }}
          width='16px'
          height='16px'
        />
        <CTAText>SCHEDULE</CTAText>
      </Container>
    </>
  )
}
export default AddToCalendarBtnForClassCard
